import React, {useState} from 'react';
import HeaderDropdown from "../dropdown";
import HeaderButton from "../button";
import RepresentationModal from "./representationModal";
import './styles.scss';
import {toast} from "react-toastify";
import Info from '../../../../components/Info';

const Representation = ({value, setValue, options, columns, save, loading, onDelete}) => {
    const initModalData = {
        open: false,
        representation: null
    };
    const [modalData, setModalData] = useState(initModalData)

    const valueFromOptions = (value) => {
        var optionValue = (options || []).find(o => o.value == value);
        return value && optionValue ? optionValue.data : null;
    }

    return (
        <div className='header-btns'>
            <HeaderDropdown
                options={options}
                icon='table'
                value={(value || {}).id}
                withLeftLine
                onChange={(e, {value}) => setValue(valueFromOptions(value))}
            />
            <HeaderButton
                icon='settings'
                name='Настройка данных'
                withLeftLine
                onClick={() => setModalData({
                    open: true,
                    representation: value
                })}
                disabled={(value || {}).isReadOnly}
            />
            {(value || {}).isReadOnly && 
                <Info
                    name='Стандартный отчёт'
                    text='Стандартный отчёт не редактируется. Для настройки отчёта создайте новый отчёт или выберете отчет из ранее созданных отчетов. При желании сделайте "новый отчет" основным, тогда он будет открываться по умолчанию.'
                    className='blocked-edit-grid-info'
                />
            }
            <HeaderButton
                icon='plus-new'
                name='Создать новый отчет'
                withLeftLine
                onClick={() => setModalData({
                    open: true
                })}
            />
            <RepresentationModal
                loading={loading}
                columns={columns}
                options={options}
                open={modalData.open}
                representation={modalData.representation}
                onClose={() => setModalData(initModalData)}
                onSave={(d) => {
                    if ((options || []).filter(o => d.id ? (o.value !== d.id) : true).map(o => o.text).includes(d.name)) {
                        toast.error('Такое название отчета уже есть. Пожалуйста, переименуйте отчет')
                    } else if (!(d.columns || []).length) {
                        toast.error('Пожалуйста, добавьте хотя бы одно поле в данные вашего отчета')
                    } else {
                        save(d).then(() => setModalData(initModalData));
                    }
                }}
                onDelete={onDelete}
            />
        </div>
    );
};

export default Representation;


// WEBPACK FOOTER //
// ./App/pages/reports/components/representation/representation.jsx